import { Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useT } from '@/lib/i18n';
import { useTheme } from '@/lib/theme';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const t = useT();
  return (
    <Button
      variant="ghost"
      size="icon"
      className="size-10 sm:size-8"
      onClick={toggle}
      aria-label={t.theme()}
      title={theme === 'dark' ? t.themeLight() : t.themeDark()}
    >
      {theme === 'dark' ? <Sun /> : <Moon />}
    </Button>
  );
}
